export interface WebsiteMigrationActionLog {
  id: number,
  log: string,
  createdDate: string;
}

export interface WebsiteMigrationAction {
  id: number;
  action: string;
  parentActionsIds: number[];
  logs: WebsiteMigrationActionLog[];
  status: string;
  priority?: string;
  createdDate: string;
  updatedDate: string;
}

export interface WebsiteMigration {
  id: number;
  sourceWebsiteId: number;
  targetWebsiteId: number;
  type: string;
  status: string;
  actions: WebsiteMigrationAction[];
  createdDate: string;
  updatedDate: string;
}

export interface WebsiteMigrationsResponse {
  page: number;
  itemsPerPage: number;
  totalItems: number;
  migrations: WebsiteMigration[];
}

export type MigrationType = {
  rename: string;
  mainToMain: string;
  subToSub: string;
};


export interface WebsiteMigrationMessageInterface {
  payload: WebsiteMigrationMessagePayloadInterface;
}

export interface WebsiteMigrationMessagePayloadInterface {
  id: number,
  sourceWebsiteId: number,
  targetWebsiteId: number,
  status: string,
  actions: WebsiteMigrationAction[],
}

export interface WebsiteMigrationActionMessagePayloadInterface {
  id: number,
  status: string,
  logs: string[],
}

export interface WebsiteMigrationActionMessageInterface {
  payload: WebsiteMigrationActionMessagePayloadInterface;
}

export enum OrchestratorActionType {
  CREATION = 'creation',
  DELETION = 'deletion',
  MIGRATION = 'migration',
}

export enum OrchestratorActionStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in progress',
  FAILED = 'failed',
  RETRY = 'retry',
  RETRYING = 'retrying',
  DONE = 'done',
  ROLLING_BACK = 'rolling back',
  ROLLED_BACK = 'rolled back',
  CANCELLED = 'cancelled',
}

export default interface WebsiteMigrationsRepositoryInterface {
  getAllMigrations(
    page: number,
    itemsPerPage: number,
    sourceWebsiteId?: number,
    targetWebsiteId?: number,
    type?: string,
    status?: string,
  ): Promise<WebsiteMigrationsResponse>;

  getMigration(id: number): Promise<WebsiteMigration>;

  renameWebsite(id: number, newDomain: string, excludeActions: string[]): Promise<void>;

  getMigrationsBySourceAndTargetGroups(sourceGroupId?: number, targetGroupId?: number): Promise<WebsiteMigration[]>;

  updateMigrationActionStatus(
    migrationId: number,
    actionId: number,
    actionType: OrchestratorActionType,
    status: OrchestratorActionStatus,
  ): Promise<void>;

  createMigration(
    sourceWebsiteId: number,
    sourceGroupId: number,
    sourceServerId: string,
    targetServerId: string,
    targetGroupId: number,
  ): Promise<void>;
}
